import { AlertProps, ComponentsOverrides, Theme } from '@mui/material';

import { CloseIcon } from '../icons';

export const MuiAlert: {
    styleOverrides: ComponentsOverrides<Theme>['MuiAlert'];
    defaultProps: Partial<AlertProps>;
} = {
    styleOverrides: {
        root: ({ theme }) => ({
            padding: theme.spacing(1, 2),
            color: theme.palette.text.primary,
            alignItems: 'center',
        }),
        icon: {
            padding: 0,

            svg: {
                width: 20,
                height: 20,
            },
        },
        message: {
            padding: 0,
        },
        action: {
            padding: 0,
        },
        filled: {
            borderRadius: 0,
        },
        filledInfo: ({ theme }) => ({
            backgroundColor: theme.palette.alertInfo.light,
        }),
        filledSuccess: ({ theme }) => ({
            backgroundColor: theme.palette.alertSuccess.light,
        }),
        filledWarning: ({ theme }) => ({
            backgroundColor: theme.palette.alertWarning.light,
        }),
        filledError: ({ theme }) => ({
            backgroundColor: theme.palette.alertError.light,
        }),
        outlinedInfo: ({ theme }) => ({
            borderColor: theme.palette.alertInfo.main,
            backgroundColor: theme.palette.alertInfo.light,
        }),
        outlinedSuccess: ({ theme }) => ({
            borderColor: theme.palette.alertSuccess.main,
            backgroundColor: theme.palette.alertSuccess.light,
        }),
        outlinedWarning: ({ theme }) => ({
            borderColor: theme.palette.alertWarning.main,
            backgroundColor: theme.palette.alertWarning.light,
        }),
        outlinedError: ({ theme }) => ({
            borderColor: theme.palette.alertError.main,
            backgroundColor: theme.palette.alertError.light,
        }),
    },
    defaultProps: {
        components: {
            CloseIcon: CloseIcon,
        },
    },
};

export const MuiAlertTitle: {
    styleOverrides: ComponentsOverrides<Theme>['MuiAlertTitle'];
} = {
    styleOverrides: {
        root: ({ theme }) => ({
            ...theme.typography.body2,
            fontWeight: 600,
            margin: 0,
        }),
    },
};
